import { observable, action, decorate } from 'mobx';
import { firebaseApp } from '../firebase';

export default class MainStore {
  constructor() {
    this.authUser = null;
    this.authenticated = false;
    this.isAdmin = false;
    this.isMember = false;
    this.listings = {
      listedEvents: null,
      unlistedEvents: null
    }
    this.preListings =  {
      preStagedEvents: null,
      stagedEvents: null
    }

    this.signOut = this.signOut.bind(this);
    this.signIn = this.signIn.bind(this);
    this.checkAdmin = this.checkAdmin.bind(this);
    this.checkMember = this.checkMember.bind(this);
    this.getListings = this.getListings.bind(this);
    this.getAllPreListings = this.getAllPreListings.bind(this);
    this.approveEvent = this.approveEvent.bind(this);
    this.deleteEvent = this.deleteEvent.bind(this);
    this.forceListEvent = this.forceListEvent.bind(this);
    this.editEvent = this.editEvent.bind(this);
    this.unlistEvent = this.unlistEvent.bind(this);
    this.relistEvent = this.relistEvent.bind(this);
    this.duplicateEvent = this.duplicateEvent.bind(this);
    firebaseApp.auth().onAuthStateChanged((user) => {
      if(user) {
        console.log('a user is signed in...');
        this.authUser = user;
        this.authenticated = true;
        this.checkAdmin(user.uid);
        this.checkMember(user.uid);
        return;
      }
    })

    //  DIRECTORY ENTITIES
    this.directory = [];
    this.fetchDirectory = this.fetchDirectory.bind(this);
    this.updateDirectory = this.updateDirectory.bind(this);
    this.loadingDirectory = true;
  }

  async fetchDirectory () {

    const url = "https://us-central1-funily-deals.cloudfunctions.net/fetchAllDirectory";

    try {

      let initiateFetch = await fetch(url);
      let jsonRes = await initiateFetch.json();

      jsonRes.forEach(item => {
        if(!item.hasOwnProperty('imageUrl')) {
          item.imageUrl = "";
        }
      })

      this.loadingDirectory = false;
      this.directory = jsonRes;
    } catch (e) {
      console.log('error fetchDirectory',e);
      this.loadingDirectory = false;
      throw e;
    }

  }

  async updateDirectory (directoryItem) {

    let jsonBody = {
      _id: directoryItem._id,
      directory: directoryItem
    }

    // this.loadingDirectory = true;

    const url = "https://us-central1-funily-deals.cloudfunctions.net/updateDirectoryItem"

    let options = {
      method: 'Post',
      body: JSON.stringify(jsonBody)
    }

    try {

      let initiateUpdate = await fetch(url,options);
      let jsonRes = await initiateUpdate.json();

      console.log('Successfully updated directory item...', jsonRes);
      this.loadingDirectory = false;

    } catch (e) {

      console.log('error updating directory',e);
      // this.loadingDirectory = false;
      throw e;

    }




  }

  async unlistEvent (eventObj) {

    const saveUrl = "https://us-central1-funily-deals.cloudfunctions.net/saveToMongo";
    const removeUrl = "https://us-central1-funily-deals.cloudfunctions.net/removeFromMongo";

    //  REMOVE ID FROM EVENT BEFORE SAVING TO AVOID CONFLICT
    delete eventObj._id;

    let saveOptions = {
      method: "Post",
      body: JSON.stringify({
        toSave: eventObj,
        collection: "unlistedEvents"
      })
    }

    let removeOptions = {
      method: "Post",
      body: JSON.stringify({
        deal_code: eventObj.deal_code,
        collection: "events"
      })
    }

    try {

      //  SAVE THE EVENT FIRST
      let saveEvent = await fetch(saveUrl,saveOptions);
      let saveJson = await saveEvent.json();

      console.log('saveJson',saveJson);

      //  REMOVE EVENT
      let removeEvent = await fetch(removeUrl, removeOptions);
      let removeJson = await removeEvent.json();

      console.log('removeJson',removeJson);

      //  UPDATE LOCAL ARRAYS
      let tempListings = this.listings;

      tempListings.listedEvents = tempListings.listedEvents.filter(item => item.deal_code !== eventObj.deal_code)

      tempListings.unlistedEvents.push(eventObj);

      this.listings = tempListings;


    } catch (e) {
      console.log("ERROR UNLISTING");
      throw e;
    }

 }

  async relistEvent (eventObj) {

   const saveUrl = "https://us-central1-funily-deals.cloudfunctions.net/saveToMongo";
   const removeUrl = "https://us-central1-funily-deals.cloudfunctions.net/removeFromMongo";

   let objCopy = eventObj;

   //  REMOVE ID FROM EVENT BEFORE SAVING TO AVOID CONFLICT
   delete eventObj._id;

   let saveOptions = {
     method: "Post",
     body: JSON.stringify({
       toSave: eventObj,
       collection: "events"
     })
   }

   let removeOptions = {
     method: "Post",
     body: JSON.stringify({
       deal_code: eventObj.deal_code,
       collection: "unlistedEvents"
     })
   }

   try {

     //  SAVE THE EVENT FIRST
     let saveEvent = await fetch(saveUrl,saveOptions);
     let saveJson = await saveEvent.json();

     // console.log('saveJson',saveJson);

     //  REMOVE EVENT
     let removeEvent = await fetch(removeUrl, removeOptions);
     let removeJson = await removeEvent.json();

     // console.log('removeJson',removeJson);

     //  UPDATE LOCAL ARRAYS
     let tempListings = this.listings;

     tempListings.unlistedEvents = tempListings.unlistedEvents.filter(item => item.deal_code !== eventObj.deal_code)

     tempListings.listedEvents.push(eventObj);

     this.listings = tempListings;


   } catch (e) {
     console.log("ERROR RELISTING");
     throw e;
   }

 }

  async getListings () {
    let { uid } = this.authUser;
    // uid = "0aVB1GclgyNaQOgNo3Ln87j732j2";
    const url = "https://us-central1-funily-deals.cloudfunctions.net/getVendorListings";

    let options = {
      method: "Post",
      body: JSON.stringify({uid:uid})
    }

    try {

      let getListing = await fetch(url,options);
      let jsonRes = await getListing.json();

      this.listings = jsonRes;

    } catch (e) {
      console.log("ERROR GETTING LISTING",e);
      throw e;
    }

  }

  async getAllListings () {
    const url = "https://us-central1-funily-deals.cloudfunctions.net/getAllListings";

    try {

      let getListing = await fetch(url);
      let jsonRes = await getListing.json();

      this.listings = jsonRes;

    } catch (e) {
      console.log("ERROR GETTING ALL LISTINGS",e);
      throw e;
    }
  }

  async getAllPreListings() {
    const url = "https://us-central1-funily-deals.cloudfunctions.net/getAllPreListings";

    try {

      let getListings = await fetch(url);
      let jsonRes = await getListings.json();

      this.preListings = jsonRes;

    } catch (e) {

      throw e;

    }
  }

  async approveEvent (eventObj) {
    delete eventObj._id;

    const url = "https://us-central1-funily-deals.cloudfunctions.net/saveToMongo";
    let options = {
      method: "Post",
      body: JSON.stringify({
        collection: 'stagedEvents',
        toSave: eventObj
      })
    }

    try {

      let saveEvent = await fetch(url,options);
      let jsonRes = await saveEvent.json();

      //  UPDATE PRELISTINGS
      let tempList = this.preListings;

      tempList.stagedEvents.push(eventObj);
      tempList.preStagedEvents = tempList.preStagedEvents.filter(item => item.deal_code !== eventObj.deal_code);

      this.preListings = tempList;

      //  REMOVE FROM PRESTAGED
      this.deleteEvent(eventObj,'preStaged')

    } catch (e) {
      console.log('Error approving event',e);
      throw e;
    }

  }

  async forceListEvent (eventObj) {
    delete eventObj._id;

    console.log('About to Force List',eventObj);

    const url = "https://us-central1-funily-deals.cloudfunctions.net/saveToMongo";
    let options = {
      method: "Post",
      body: JSON.stringify({
        collection: 'events',
        toSave: eventObj
      })
    }

    try {

      let saveEvent = await fetch(url,options);
      let jsonRes = await saveEvent.json();

      //  UPDATE PRELISTINGS
      let tempList = this.preListings;

      // tempList.stagedEvents = tempList.stagedEvents.filter(item => item.deal_code !== eventObj.deal_code);
      //
      // this.preListings = tempList;

      //  REMOVE FROM PRESTAGED
      this.deleteEvent(eventObj,'stagedEvents')

    } catch (e) {
      console.log('Error force listing event',e);
      throw e;
    }

  }

  async editEvent (eventObj,collection) {

    delete eventObj._id;
    const url = "https://us-central1-funily-deals.cloudfunctions.net/editEvent";
    let options = {
      method: "Post",
      body: JSON.stringify({
        eventObj: eventObj,
        collection: collection
      })
    }

    try {

      let makeEdit = await fetch(url,options);
      let jsonRes = await makeEdit.json();

      //  UPDATE LOCAL EVENTS TO REFLECT CHANGE
      let tempEvents = this.listings;

      tempEvents.listedEvents.forEach(item => {
        if(item.deal_code == eventObj.deal_code) {
          let tempItem = { ...item, ...eventObj }
          item = tempItem;
        }
        return true;
      })

      tempEvents.unlistedEvents.forEach(item => {
        if(item.deal_code == eventObj.deal_code) {
          let tempItem = { ...item, ...eventObj }
          item = tempItem;
        }
        return true;
      })

      this.listings = tempEvents;

    } catch (e) {
      console.log("Error editing event", e);
      throw e;
    }

  }

  async deleteEvent (eventObj,collection) {
    const url = "https://us-central1-funily-deals.cloudfunctions.net/removeFromMongo";
    let options = {
      method: "Post",
      body: JSON.stringify({
        collection: collection,
        deal_code: eventObj.deal_code
      })
    }

    try {

      let removeEvent = await fetch(url,options);
      let jsonRes = await removeEvent.json();

      switch(collection) {
        case "preStaged":
        case "stagedEvents":

          //  UPDATE PRELISTINGS
          let tempPreList = this.preListings;

          tempPreList.preStagedEvents = tempPreList.preStagedEvents.filter(item => item.deal_code !== eventObj.deal_code);

          tempPreList.stagedEvents = tempPreList.stagedEvents.filter(item => item.deal_code !== eventObj.deal_code);

          this.preListings = tempPreList;

          break;

        case "events":
        case "unlistedEvents":

          //  UPDATE LISTINGS
          let tempList = this.listings;

          tempList.listedEvents = tempList.listedEvents.filter(item => item.deal_code !== eventObj.deal_code);

          tempList.unlistedEvents = tempList.unlistedEvents.filter(item => item.deal_code !== eventObj.deal_code);

          this.listings = tempList;

          break;
      }



    } catch (e) {
      console.log('Error removing event',e);
      throw e;
    }

  }

  async duplicateEvent (eventObj) {

    delete eventObj._id;
    eventObj.deal_code = Math.random().toString(36).substring(2,8) + Math.random().toString(36).substring(2,8)
    const url = "https://us-central1-funily-deals.cloudfunctions.net/saveToMongo";
    let options = {
      method: "Post",
      body: JSON.stringify({
        collection: "unlistedEvents",
        toSave: eventObj
      })
    }

    try {

      let saveEvent = await fetch(url,options);
      let jsonRes = await saveEvent.json();

      this.getAllListings();

    } catch (e) {
      console.log('ERROR DUPLICATING EVENT',e);
      throw e;
    }

  }

  signIn (user,password) {
    console.log('signing in...')
    firebaseApp.auth().signInWithEmailAndPassword(user,password)
      .then(res => {
        this.authUser = res.user;
        this.authenticated = true;
        this.checkAdmin(res.user.uid);
      })
      .catch(function(err){
        console.log('error signing in',err);
      })
  }

  signOut () {
    console.log('signing out...');
    firebaseApp.auth().signOut()
      .then(() => {
        this.authenticated = false;
        this.authUser = null;
        this.isAdmin = false;
        this.listings = {
          listedEvents: null,
          unlistedEvents: null
        }
      })
      .catch(err => console.log('err signing out', err))

  }

  async checkAdmin (uid="12345") {

    const url = "https://us-central1-funily-deals.cloudfunctions.net/checkAdmin";
    let options = {
      method: "Post",
      body: JSON.stringify({uid:uid})
    }

    try {

      let isAdmin = await fetch(url,options);
      let jsonRes = await isAdmin.json();
      this.isAdmin = jsonRes;

    } catch (e) {

      throw e;
    }

  }

  async checkMember (uid="12345") {

    const url = "https://us-central1-funily-deals.cloudfunctions.net/checkMember";

    let options = {
      method: "Post",
      body: JSON.stringify({uid:uid})
    }

    try {

      let isMember = await fetch(url,options);
      let jsonRes = await isMember.json();

      this.isMember = jsonRes;

    } catch (e) {

      throw e;
    }

  }

} // class

decorate(MainStore, {
  authUser: observable,
  authenticated: observable,
  checkAdmin: action,
  signIn: action,
  signOut: action,
  listings: observable,
  isAdmin: observable,
  getAllListings: action,
  getListings: action,
  preStagedEvents: observable,
  stagedEvents: observable,
  getAllPreListings: action,
  preListings: observable,
  approveEvent: action,
  deleteEvent: action,
  forceListEvent: action,
  editEvent: action,
  unlistEvent: action,
  relistEvent: action,
  duplicateEvent: action,
  directory: observable,
  fetchDirectory: action,
  loadingDirectory: observable,
  updateDirectory: action,
  showDirectory: observable,
  checkMember: action,
  isMember: observable
})



// WEBPACK FOOTER //
// ./src/stores/main.store.js